import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 16px;

  .slider {
    .slick-slider {
      .slick-list {
        overflow: visible;
      }

      .slick-slide {
        display: block;
        padding: 0 4px;
      }

      .slick-dots {
        position: relative;
        bottom: auto;
        margin-top: 16px;

        li {
          transition: all 0.3s linear;
          transform-origin: center;
          button {
            margin-top: 0;
          }
        }
      }
    }
  }

  svg {
    width: 100%;
    height: 100%;
  }

  button {
    margin-top: 25px;
  }
`
